import { menu } from "@/api/login";
import { APP_LIST } from "@/configs/childAppConfig";
import router from "@/router";
import { IamRouterTable } from "@/types/api/login";
import { labelForChildApp, serializRouter } from "@/utils/parsingRouter";
import storage from "store";
export interface OriginMenusType {
  funcId: string;
  appName: string;
  portalId: string;
  funcName: string;
  name?: string;
  path: string;
  status: boolean;
  funcType: string;
  children: any[];
  hasChildren: boolean;
  funcSort: number;
  isShow: number;
  component: string;
  icon: string;
  query: string;
  id: string;
  permissions: string[];
}

export function handleOriginMenus(menuList: OriginMenusType[]) {
  const res: any[] = [];
  const queryKeys: Array<string> = [];
  // 定义一个名为 handle 的函数，用于处理菜单列表
  function handle(list: OriginMenusType[]) {
    // 遍历菜单列表 menuList 中的每一个项目 item
    list.forEach((item) => {
      // 检查当前项目 item 是否有 query 属性
      if (item.query) {
        // 如果有 query 属性，将其添加到 queryKeys 数组中
        queryKeys.push(item.query);
      }
      // 检查当前项目 item 是否有 children 属性且 children 数组不为空
      if (item.children && item.children.length) {
        // 如果有子菜单，调用 handleOriginMenus 函数处理子菜单
        const children = handle(item.children);
        // 将当前项目 item 和处理后的子菜单 children 组合成一个新对象，并添加到 res 数组中
        res.push({
          ...item, // 使用扩展运算符复制 item 对象的所有属性
          children, // 添加处理后的子菜单
        });
      } else {
        // 如果没有子菜单，直接将当前项目 item 添加到 res 数组中
        res.push(item);
      }
    });
  }
  handle(menuList);
  return { queryKeys };
}

export async function handleGetMenuList() {
  let menuList = storage.get("menuList");
  const codesFun = APP_LIST.map(
    async (item) => await menu({ portalCode: item.sysCode })
  );
  // const getMenuFun = codes.map
  const responses = await Promise.all(codesFun);
  menuList = serializRouter(
    [],
    responses.map(
      (res) =>
        labelForChildApp(
          res.data.data,
          res.config.params.portalCode
        ) as unknown as IamRouterTable[]
    )
  );
  storage.set("menuList", menuList);
  return {};
}
/**
 * 获取页面的权限
 */
export function getPagePermissions(item: OriginMenusType) {
  const permissions: string[] = [];

  if (item.permissions && item.permissions.length) {
    permissions.push(...item.permissions.filter((permission) => permission));
  }
  if (item.children && item.children.length) {
    for (const child of item.children) {
      permissions.push(...getPagePermissions(child));
    }
  }

  return permissions;
}

export function handlePageListInfo(
  list: OriginMenusType[],
  pageInfo: any = {},
  isRoot = false
) {
  for (const item of list) {
    if (item.appName && !isRoot) {
      if (!pageInfo[item.appName]) {
        pageInfo[item.appName] = {};
      }
      const permissions = getPagePermissions(item);
      pageInfo[item.appName][item.path] = {
        appName: item.appName,
        name: item.name,
        path: item.path,
        id: item.id,
        permissions: permissions,
      };
    }

    if (item.children) {
      handlePageListInfo(item.children, pageInfo);
    }
  }
  return pageInfo;
}

export const processMenuData = (data: any[], routerMap: any = {}) => {
  // 1. 根据funcSort升序排序
  const sortedData = [...data].sort((a, b) => a.funcSort - b.funcSort);

  // 2. 处理TAB类型并按sysCode分类
  const processItem = (item: any) => {
    if (item.funcType === "TAB") {
      try {
        const query = JSON.parse(item.query || "{}");
        const sysCode = query.sysCode || "DEFAULT";

        if (!routerMap[sysCode]) {
          routerMap[sysCode] = [];
        }

        // 保留原始结构
        const newItem = { ...item };
        if (item.children && item.children.length) {
          newItem.children = processMenuData(item.children);
        }
        if (routerMap) routerMap[sysCode].push(newItem);
      } catch (e) {
        // Error handling without console.log
      }
    }
    return item;
  };

  sortedData.forEach((data) => {
    processItem(data);
  });
  return routerMap;
};

export interface FuncItem {
  funcId: string;
  portalId: string;
  funcName: string;
  path: string;
  status: boolean;
  funcType: string;
  children: FuncItem[];
  hasChildren: boolean;
  funcSort: number;
  isShow: number;
  component: string;
  icon: string;
  query: string;
  appName: string;
  name?: string;
  id: string;
  permissions: any;
}

interface ResultType {
  [key: string]: FuncItem[];
}

export function transformDataToResult(data: FuncItem[]): ResultType {
  const result: ResultType = {};

  // 递归处理每个节点
  function processNode(node: FuncItem): FuncItem | null {
    // 克隆节点，避免修改原始数据
    const newNode: FuncItem = { ...node, children: [] };

    // 处理子节点
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        const processedChild = processNode(child);
        if (processedChild) {
          newNode.children.push(processedChild);
        }
      }
    }

    // 检查当前节点是否有 query 并且包含 sysCode
    if (node.query) {
      try {
        const queryObj = JSON.parse(node.query);
        if (queryObj.sysCode) {
          const sysCode = queryObj.sysCode;

          // 初始化该 sysCode 的数组（如果不存在）
          if (!result[sysCode]) {
            result[sysCode] = [];
          }

          // 检查是否已经存在相同 funcId 的顶级节点
          const existingTopLevelNode = result[sysCode].find(
            (item) => item.funcId === node.funcId
          );

          if (!existingTopLevelNode) {
            // 如果没有，则添加当前节点的顶级副本（不包含子节点）
            const topLevelNode = { ...node };
            result[sysCode].push(topLevelNode);
          }
          // 返回处理后的节点（包含子节点）
          return newNode;
        }
      } catch (e) {
        // Error handling without console.log
      }
    }

    // 如果没有 query 但有子节点，则返回处理后的节点
    if (newNode.children.length > 0) {
      return newNode;
    }
    // 否则返回 null 表示不需要包含此节点
    return null;
  }

  // 遍历原始数据
  for (const item of data) {
    processNode(item);
  }

  return result;
}

export function getAllBtnAndAttrAuth(data: FuncItem[]): Array<string> {
  const allAuth: Array<string> = [];
  if (!data.length) return allAuth;
  for (const item of data) {
    if (item.funcName === "全局按钮属性权限") {
      for (const vo of item.children) {
        allAuth.push(vo.component);
      }
      break;
    }
  }
  return allAuth;
}

export function checkIsPageAuth(appName: string, path: string): boolean {
  const localPages = JSON.parse(localStorage.getItem("pageListInfo") || "{}");
  if (!localPages) {
    return false;
  }
  const sysPageList = localPages[appName];
  if (sysPageList && sysPageList[path]) {
    return true;
  } else {
    const routeList = router.getRoutes();
    if (routeList.find((v) => v.name === path)) {
      return true;
    }
  }
  return false;
}
export function getPathBeforeLastSlash(path: string): string {
  if (!path) return "";
  const idx = path.lastIndexOf("/");
  return idx !== -1 ? path.substring(0, idx) : path;
}
export function getLastPathSegment(path: string): string {
  if (!path) return "";
  const idx = path.lastIndexOf("/");
  return idx !== -1 ? path.substring(idx + 1) : path;
}

export function filterRouterHidden(routerList: any[]): any[] {
  const List = [];
  if (routerList.length) {
    for (const item of routerList) {
      if (item.funcType === "DIR") {
        if (item.children.length) {
          item.children = filterRouterHidden(item.children);
        }
        if (item.children.length) {
          List.push(item);
        }
      } else {
        if(item.hidden) continue;
        List.push(item);
      }
    }
  }
  return List;
}
